import { useMsal } from "@azure/msal-react";
import { useEffect, useState } from "react";
import { InteractionStatus } from "@azure/msal-browser";

import resolveUserName from "./resolveUserName";

export default function IdentityManager() {
    const { instance, inProgress, accounts } = useMsal();
    const [apiData] = useState(null);

    useEffect(() => {
        // El guard de cuenta ausente cubre el re-render que dispara `logoutRedirect` al
        // limpiar la caché de MSAL antes de navegar al IdP.
        if (inProgress !== InteractionStatus.None || accounts.length === 0) {
            return;
        }

        const account = accounts[0];
        const userName = resolveUserName(account);
        localStorage.setItem("_urn", Buffer.from(userName).toString('base64'));
        localStorage.setItem("_fullName", account.name ?? userName);
        localStorage.setItem("_userName", userName);
    }, [instance, accounts, inProgress, apiData]);

    return '';
}
